import React, { useEffect, useState } from 'react';
import { Form, Table, Row, Col, DatePicker, Button, Space, Dropdown, message, Divider } from 'antd';
import { useHistory } from 'react-router-dom';
import { getQualityTask, getQualityTaskInfo } from '../util/api';
import { createPDF, downLoad } from '../../../util/tool';
import Print from './print';
import '../qualityGradient/index.less';
// import CpEmpty from '../../../components/CpEmpty';
import moment from 'moment';
import { Tooltip } from 'antd';
import { hideLoading, showLoading } from '../../../util/loading';

const { RangePicker } = DatePicker;
const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
};
let timerId = null;
const QualityTask = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [info, setInfo] = useState({});
  // const [flag, setFlag] = useState(false);
  const [page, setPage] = useState({
    page: 1,
    page_size: 10
  });
  const columns = [
    {
      title: '序号',
      dataIndex: 'id',
      align: 'center',
    },
    {
      title: '质检日期',
      dataIndex: 'create_time',
      align: 'center',
    },
    {
      title: '质检商品',
      dataIndex: 'products',
      align: 'center',
      render: (arr) => {
        if (arr.length > 1) {
          return (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 4px' }}>
              <Tooltip title={arr[0]}>
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: 190 }}>{arr[0]}</span>
              </Tooltip>
              <Dropdown
                placement="top"
                overlay={
                  <div style={{ padding: 10, background: '#fff', boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.23)', textAlign: 'center' }}>
                    <div >商品名称</div>
                    <Divider style={{ margin: 0 }} />
                    {
                      arr.map((item, i) => {
                        return <div key={i}>{item}</div>;
                      })
                    }
                  </div>
                }
              >
                <div>
                  <a onClick={(e) => e.preventDefault()} style={{ color: '#1890FF' }}>
                    <Space>
                      详情
                    </Space>
                  </a>
                </div>
              </Dropdown>
            </div>

          );
        } else if (arr.length === 1) {
          return <span>{arr[0]}</span>;
        }
        return '-';
      }

    },
    {
      title: '质检数量',
      dataIndex: 'products_count',
      align: 'center',
      render: (val) => {
        return val ? val : '-';
      }
    },
    {
      title: '合格率',
      dataIndex: 'type_rate_1',
      align: 'center',
      render: val => val === '-' ? '-' : `${val}%`
    },
    {
      title: '退货率',
      dataIndex: 'type_rate_2',
      align: 'center',
      render: val => val === '-' ? '-' : `${val}%`
    },
    {
      title: '换货率',
      dataIndex: 'type_rate_3',
      align: 'center',
      render: val => val === '-' ? '-' : `${val}%`
    },
    {
      title: '扣重收货率',
      dataIndex: 'type_rate_4',
      align: 'center',
      render: val => val === '-' ? '-' : `${val}%`
    },
    {
      title: '质检状态',
      dataIndex: 'status',
      align: 'center',
      render: (val) => +val === 1 ? '质检中' : '质检完成'
    },
    {
      title: '操作',
      dataIndex: 'op',
      align: 'center',
      fixed: 'right',
      render: (_, record) => {
        return (
          <>
            <Space>
              <span style={{ cursor: 'pointer' }} onClick={() => history.push('/basic/user/qualityTask/detail/' + record.id)}>查看</span>
              {
                record.products.length && record.status === 2 ? (<span>下载(<span style={{ color: '#1890FF', cursor: 'pointer' }} onClick={() => createPdfMethod(record)}>PDF</span> | <span style={{ color: '#1890FF', cursor: 'pointer' }} onClick={() => downloadExel(record)}>{+record.file_status === 0 ? '生成 Excel' : (+record.file_status === 1 ? '生成中' : 'Excel')}</span>)</span>) : ''
              }
            </Space>
          </>
        );
      }
    }
  ];
  const [total, setTotal] = useState(0);
  const [list, setList] = useState([]);

  const downloadExel = async (record) => {
    if (+record.file_status === 0) {
      showLoading();
      getQualityTaskInfo({
        id: record.id,
        export: 1
      }).then(() => {
        getList().then(() => {
          message.loading('操作成功，正在生成Excel，请稍后！', 2, () => {
            hideLoading();
          });
        });
      });
    } else if (+record.file_status === 1) {
      message.loading('Excel生成中，请等待！');
    } else {
      const fileName = moment(record?.create_time).format('YYYY年MM月DD日');
      downLoad({
        url: record.file_url,
        name: `${fileName}质检记录(序号-${record.id}).xlsx`
      });
    }
  };
  const createPdfMethod = async (record) => {
    const fileName = moment(record?.create_time).format('YYYY年MM月DD日');
    const res = await getQualityTaskInfo({
      id: record.id
    });
    const { code, data = {}, msg } = res.data || {};
    if (code === 0) {
      setInfo(data);
      // setFlag(true);
      await createPDF({ fileName: `${fileName}质检记录(序号-${record.id}).pdf`, content: `<div style='width: 1600px'>${document.querySelector('.i-print-wrapper').innerHTML}<div>`, width: 1600 });
      setInfo({});
      // setFlag(false);
    } else {
      message.error(msg);
    }
  };
  const tablePageChange = (page, page_size) => {
    setPage({ page, page_size });
  };

  const getList = async () => {
    const values = form.getFieldsValue();
    const result = await getQualityTask({
      quality_date_start: values.quality_date ? moment(values.quality_date[0]).format('YYYY-MM-DD') : '',
      quality_date_end: values.quality_date ? moment(values.quality_date[1]).format('YYYY-MM-DD') : '',
      ...page,
    });
    const { code, data: { list = [], total } = {} } = result.data || {};
    if (code === 0) {
      setList(list);
      setTotal(total);
      for (var i = 0; i < list.length; i++) {
        if (+list[i].file_status === 1) {
          if (timerId !== null) {
            clearTimeout(timerId);
          }
          timerId = setTimeout(function () {
            getList();
          }, 10000);
          return;
        }
      }
    }
  };
  const handleQuery = () => {
    setPage({ page: 1, page_size: 10 });
  };

  const reset = () => {
    form.resetFields(['quality_date']);
    setPage({ page: 1, page_size: 10 });
  };
  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);
  // const empty = (
  //   <div className="address-empty">
  //     <CpEmpty status={'qualityTask'} />
  //   </div>
  // );
  return (
    <>
      <h2 >质检记录</h2>
      <div>
        {Reflect.ownKeys(info)?.length ?
          <div style={{ position: 'absolute', left: -20000, top: -20000, zIndex: -100 }}><Print info={info} /></div>
          : null}
        <Form {...layout} onFinish={handleQuery} form={form}>
          <Row span={24}>
            <Col span={12}>
              <Form.Item
                label="质检日期"
                name="quality_date"
              >
                <RangePicker />
              </Form.Item>
            </Col>
            <Col span={8} offset={4}>
              <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Space>
                  <Button type="primary" htmlType="submit">
                    查询
                  </Button>
                  <Button onClick={reset} >
                    重置
                  </Button>
                </Space>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <div>
          <Table
            columns={columns}
            dataSource={list}
            rowKey={'id'}
            className='quality-table-cell'
            bordered
            pagination={{
              pageSize: page.page_size,
              total: total,
              current: page.page,
              onChange: tablePageChange
            }}
            scroll={{ x: 'max-content' }}
          />
        </div>
      </div>
    </>
  );
};

export default QualityTask;